import gql from "graphql-tag";

export const CustomGetStaffMyselfState = gql`
  query getStateMyself {
    getStaffMyself {
      id_account
      tenant_id
      name
      state
      role
    }
  }
`;
